import w from "./index.es264.js";
import C from "./index.es265.js";
import S from "./index.es266.js";
import D from "./index.es267.js";
import v from "./index.es268.js";
import E from "./index.es269.js";
import k from "./index.es270.js";
var L = `<?xml version="1.0" ?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:mx="http://schemas.microsoft.com/office/mac/excel/2008/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main">{views}{columnsDescription}<sheetData>{data}</sheetData>{mergedCellsDescription}{layout}{drawing}</worksheet>`;
function b(t, e) {
  var r = e.schema, o = e.columns, a = e.images, m = e.getHeaderStyle, i = e.getStyle, n = e.getSharedString, c = e.customFont, l = e.dateFormat, h = e.orientation, p = e.stickyRowsCount, g = e.stickyColumnsCount, d = e.showGridLines, y = e.rightToLeft, u = e.sheetId;
  T(t, {
    schema: r
  });
  var s = S(t, {
    schema: r
  }), f = s.data, x = s.mergedCells;
  return L.replace("{data}", w(f, {
    schema: r,
    getHeaderStyle: m,
    getStyle: i,
    getSharedString: n,
    customFont: c,
    dateFormat: l
  })).replace("{views}", E({
    stickyRowsCount: p,
    stickyColumnsCount: g,
    showGridLines: d,
    rightToLeft: y
  })).replace("{columnsDescription}", C({
    schema: r,
    columns: o
  })).replace("{mergedCellsDescription}", D(x)).replace("{layout}", v({
    sheetId: u,
    orientation: h
  })).replace("{drawing}", k({
    images: a
  }));
}
function T(t, e) {
  var r = e.schema;
  if (r) {
    if (!Array.isArray(t))
      throw new TypeError("Expected an array of objects");
  } else {
    if (!Array.isArray(t))
      throw new TypeError("Expected an array of arrays");
    if (t.length > 0 && !Array.isArray(t[0]))
      throw new TypeError("Expected an array of arrays");
  }
}
export {
  b as default
};
//# sourceMappingURL=index.es245.js.map
